import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { config } from "./config";

async function enableMocking() {
  if (!config.mockMode) {
    return;
  }
  const { worker } = await import("./mocks/browser");
  // return worker.start({ onUnhandledRequest: "bypass" });
}

enableMocking().then(() => {
  createRoot(document.getElementById("root")!).render(<App />);
});
